import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from "react-router-dom";

import DataTable from '../../components/Table/DataTable';
import SearchBox from './../../components/SearchBox/SearchBox';
import CategoryModal from '../../components/CategoryModal/CategoryModal';

import {
  getCategories,
  deleteCategory,
  getCategoriesBySearch,
  getCategoriesByOrder,
} from '../../services/categories';
import { showAlert } from '../../store/ducks/alert';

import { CircularProgress, Button } from '@material-ui/core';
import {Add as AddIcon, Delete as DeleteIcon, Edit as EditIcon} from '@material-ui/icons';

const Categories = ({ location, match }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [categories, setCategories] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({name: "", internationalizationLanguage: {}});
  const [isUpdating, setIsUpdating] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [searchField, setSearchField] = useState({
    searchItem: '',
    search: '',
  });
  const [isOrdering, setIsOrdering] = useState(0);
  const [orderDirections, setOrderDirections] = useState({
    item: '',
    direction: '',
  });

  useEffect(() => {
    if (location.state && location.state.remount) {
      handleSubmitSearch({
        searchItem: '',
        search: '',
      });
    }
  }, [location]);

  useEffect(() => {
    if (match && match.params.searchItem && match.params.search) {
      handleSubmitSearch({
        searchItem: match.params.searchItem,
        search: match.params.search,
      });
    }
    displayCategories();
  }, [isSearching, isOrdering, page]);

  const handleSubmitSearch = searchBox => {
    setSearchField({
      ...searchField,
      searchItem: searchBox.searchItem,
      search: searchBox.search,
    });
    setIsSearching(searchBox.search);
  };
  
  const displayCategories = async () => {
    try {
      setIsLoading(true);

      let categories;
      if (isSearching) {
        const { data } = await getCategoriesBySearch(searchField.searchItem, searchField.search);
        categories = data;
      } else if (isOrdering > 0) {
        const { data } = await getCategoriesByOrder(orderDirections.item, orderDirections.direction);
        categories = data;
      } else if (!isOrdering && !isSearching && Object.keys(match.params).length === 0) {
        const { data } = await getCategories(page);
        categories = data;
      }
      if (!categories) return;

      setCategories(categories.rows);
      setTotalItems(categories.count);
      setTotalPages(categories.pages);
      setPage(categories.page);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
    }
  };

  const headers = ['id', 'name', 'slug', 'internationalizationLanguage', 'createdAt', 'updatedAt'];

  const customActions = [
    {
      "icon": <DeleteIcon />,
      "action": (item) => {
        handleDeleteCategory(item.id);
      }
    },
    {
      "icon": <EditIcon />,
      "action": (item) => {
        handleOpenUpdateCategory(item);
      }
    }
  ]

  const handleClose = () => {
    setFormData({name: "", internationalizationLanguage: {}});
    setOpen(false);
  };

  const handleOpenCategory = () => {
    setOpen(true);
  };
    
  const handleDeleteCategory = async (id) => {
    try {
      await deleteCategory(id);
      dispatch(showAlert('success', 'Category has been deleted! 🔥'));
      window.location = '/categories';
    } catch (error) {
      dispatch(showAlert('error', 'Error! We could not delete this category. 😔'));
    }
  }

  const handleOpenUpdateCategory = async(item) => {
    setIsUpdating(true)
    setFormData(item);
    setOpen(true);
  }

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;
  
  const handleGoToWithoutCategory = () => {
    history.push(`/issuesWithoutCategory`);
  }

  return (
    <>
      
      <div className="channels-container">
        <h1> Categories ({totalItems})</h1>

        <Button
          onClick={handleOpenCategory}
          variant="contained"
          className="modal-btn"
        >
          Category
          <AddIcon/>
        </Button>

        <Button
          onClick={handleGoToWithoutCategory}
          variant="contained"
          className="modal-btn"
        >
          Issues without category
        </Button>

        {open ? <CategoryModal onClose={handleClose} isUpdating={isUpdating} formData={formData}  /> : ""}

        <SearchBox selectItems={headers} onSubmitSearch={handleSubmitSearch} isSearching={isSearching} setIsOrdering={setIsOrdering} />
      </div>

      <DataTable
        head={headers}
        body={categories}
        bodyColumn={headers}
        action={true}
        customActions={customActions}
        linkPath={'categories'}
        totalPages={totalPages}
        currentPage={page}
        setPageChange={setPage}
        orderDirections={orderDirections}
        setOrderDirections={setOrderDirections}
        setIsOrdering={setIsOrdering}
        isOrdering={isOrdering}
      />
    </>
  );
};

export default Categories;
